/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { useParams, useSearchParams } from 'react-router-dom';

export function useCurrentProjectRiskId() {
  const { riskId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const project = searchParams.get('id') ?? '';

  return {
    riskId,
    project,
  };
}
